<template>
  <div class="ai-visibility-metric-grid" :style="gridStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MetricGrid',
  props: {
    columns: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    gridStyle () {
      return {
        gridTemplateColumns: `repeat(${this.columns}, minmax(0, 1fr))`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-metric-grid {
  display: grid;
  gap: 16px;
}

@media (max-width: 1080px) {
  .ai-visibility-metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 640px) {
  .ai-visibility-metric-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }
}
</style>
